import { isAnimationEnabled } from 'cadenza/utils/animation-util';

export function scrollIntoView (el: Element, behavior: ScrollBehavior = 'smooth') {
  // eslint-disable-next-line no-restricted-syntax
  el.scrollIntoView({
    block: 'nearest',
    behavior: isAnimationEnabled() ? behavior : 'auto'
  });
}
